<template>
    <div class="index">
        <!-- display:flex;align-items:center;justify-content: space-between; -->
          <div style="">
              <div>
              <el-input
                style="width: 40%;"
                placeholder="请输入内容"
                v-model="listQuery.keyword"
                @change="search()"
                clearable>
                </el-input>
                <el-button plain style="background-color:#9250E6;color:white;width: 100px;margin-left: 20px" @click="search">搜索</el-button>
                <el-button plain style="background-color:white;border:1px solid #9250E6;color:#9250E6;width: 100px;margin-left: 20px" @click="upload">点击上传</el-button>
                </div>
                <div>
                    <!-- <div style="line-height: 23px;padding: 5px 20px;background-color: white;border-radius: 10px;">
                        <p>剩余量:{{surplus}}</p>
                        <p>已使用:{{used_num}}</p>
                    </div> -->
                    <div>

                    </div>
                </div>
          </div>
            <!-- <div id="main"></div> -->
            
            <!-- 列表 -->
            <div>
                <el-table
                :data="list"
                v-loading="loading"
                stripe
                :header-cell-style="{background:'#eae8e8'}"
                header-cell-class-name="table_header"
                style="width: 100%;margin-top:20px;">
                <el-table-column type="expand">
                    <template slot-scope="props">
                            <el-steps v-if="props.row.is_tran == 1" :active="props.row.stateInfo" align-center finish-status="success" :process-status="props.row.stateNum">
                                <div style="width:10%;font-size:16px;display: flex;align-items: center;justify-content: center;">处理状态:</div> 
                                <el-step title="排队等待" icon="el-icon-timer"></el-step>
                                <el-step title="正在处理" :description="props.row.create_time" icon="el-icon-time"></el-step>
                                <el-step title="提炼完成" :description="props.row.handle_time" icon="el-icon-data-analysis"></el-step>
                                <el-step title="翻译完成" :description="props.row.tran_time" icon="el-icon-circle-check"></el-step>
                            </el-steps>
                            <el-steps v-if="props.row.is_tran == 0" :active="props.row.stateInfo" align-center  finish-status="success" :process-status="props.row.stateNum">
                                <div style="width:10%;font-size:16px;display: flex;align-items: center;justify-content: center;">处理状态:</div> 
                                <el-step title="排队等待" icon="el-icon-timer"></el-step>
                                <el-step title="正在处理" :description="props.row.create_time" icon="el-icon-time"></el-step>
                                <el-step title="提炼完成" :description="props.row.tran_time" icon="el-icon-data-analysis"></el-step>
                            </el-steps>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="create_time"
                    align="center"
                    label="上传日期">
                    <template slot-scope="scope">
                        <span>{{ scope.row.create_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="file_name"
                    label="标题"
                    align="center"
                    width="300">
                    <template slot-scope="scope">
                        <span>{{ scope.row.file_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_tran"
                    label="是否翻译"
                    align="center"
                    width="220">
                    <template slot-scope="scope">
                        <span>{{ scope.row.is_tran == 1?'是':'否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proportion"
                    width="220"
                    align="center"
                    label="英文占比">
                    <template slot-scope="scope">
                        <span>{{ scope.row.proportion }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="file_count"
                    width="220"
                    align="center"
                    label="字符数">
                    <template slot-scope="scope">
                        <span>{{ scope.row.file_count }}</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="left"
                    width="300">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.is_success == 1" @click="download(scope.row)" type="primary" plain size="mini">下载文件</el-button>
                        <el-button @click="handleClick(scope.row)" size="mini" type="danger">删除文件</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="text-align:center;margin:15px 0px;">
                <el-pagination
                    style="text-align: center;"
                    background
                    layout="total,sizes,prev, pager, next,jumper"
                    :total="total"
                    :page-sizes="[10, 20, 50]"
                    :page-size="listQuery.size"
                    @size-change="handleSizeChange"
                    :current-page.sync="listQuery.page"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name:"index",
    data(){
        return{
            listQuery:{
                keyword:"",
                page:1,
                size:10,

            },
            loading:false,
            total:null,
            list:[],
            surplus:null,
            used_num:null,
            stateNum:'success'

        }
    },
    created(){
        this.fileNumInfo()
        this.listInfo()
    },
    mounted(){},
    methods: {
        listInfo(){
            this.loading = true
            this.$http({
                url:"api/get_historical_records/",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
               params:{
                    page:this.listQuery.page,
                    size:this.listQuery.size,
                    keyword:this.listQuery.keyword,
                    organ_name:localStorage.getItem("organ_name")
               }
            }).then(res=>{
                this.loading = false
                this.list = res.data.data.data
                this.list.map(item=>{
                    if(item.state == 0){
                        item.stateNum = 'success'
                        item.stateInfo = 0
                    }else if(item.state == 1){
                        item.stateNum = 'success'
                        item.stateInfo = 1
                    }else if(item.state == 2){
                        item.stateNum = 'success'
                        item.stateInfo = 2
                    }else if(item.state == 3){
                        item.stateNum = 'success'
                        item.stateInfo = 3
                    }else if(item.state == -1){
                        item.stateNum = 'error'
                        item.stateInfo = 1
                    }else if(item.state == -2){
                        item.stateNum = 'error'
                        item.stateInfo = 2
                    }else if(item.state == -3){
                        item.stateNum = 'error'
                        item.stateInfo = 3
                    }
                })
                console.log(this.list);
                this.total = res.data.data.total
            })
        },
        // 删除文件
        handleClick(row){
            console.log(row.file_name)
            this.$confirm('是否删除 '+ row.file_name+'.pdf ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error',
                center: true
            }).then(() => {
                this.$http({
                    url:"api/delete_detail/",
                    method:'GET',
                    params:{
                        pdf_md5:row.pdf_md5,
                        organ_name:localStorage.getItem("organ_name")
                    }
                }).then(res=>{
                    if(res.data.code = 200){
                        this.$message.success(res.data.message)
                        this.listQuery.page = 1
                        this.listInfo()
                    }else{
                        this.$message.error(res.data.message)
                        this.listQuery.page=1
                        this.listInfo()
                    }
                })
               
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 下载报告
        download(row){
            this.$http({
                url:"api/download",
                method:"GET",
                params:{
                    pdf_md5:row.pdf_md5,
                    organ_name:localStorage.getItem("organ_name")
                }

            }).then(res=>{
                window.open(res.data.data)
            })
        },
        // 点击上传
        upload(){
            this.$router.push({
                path:"/uplound"
            })
        },
        // 搜索
        // initChart(){
        //     var chartDom = document.getElementById('main');
        //     var myChart = echarts.init(chartDom);
        //     var option;
        //     var datas = [
        //     [
        //         { name: '剩余量', value: this.surplus },
        //         { name: '已使用', value: this.used_num }
        //     ]
        //     ];
        //     option = {
        //     title: {
        //         // text: '个人分配量  使用量',
        //         left: 'right',
        //         top:'0%',
        //         textStyle: {
        //         color: 'black',
        //         fontWeight: 'normal',
        //         fontSize: 16
        //         }
        //     },
        //     series: datas.map(function (data, idx) {
        //         // var top = idx * 33.3;
        //         return {
        //         type: 'pie',
        //         radius: [20, 60],
        //         //   top: top + '%',
        //         top: '28%',
        //         height: '33.33%',
        //         left: '10%',
        //         width: 400,
        //         itemStyle: {
        //             borderColor: '#fff',
        //             borderWidth: 1,
        //             normal:{
        //                 color:function(colors){
        //                     var colorList = [
        //                     '#91cd77',
        //                     '#0052D9',
        //                     ];
        //                     return colorList[colors.dataIndex];
        //                 }
        //             }
        //         },
        //         label: {
        //             alignTo: 'edge',
        //             formatter: '{name|{b}}\n{time|{c}次}',
        //             minMargin: 5,
        //             edgeDistance: 100,
        //             lineHeight: 15,
        //             rich: {
        //             time: {
        //                 fontSize: 14,
        //                 color: 'black'
        //             }
        //             }
        //         },
        //         labelLine: {
        //             length: 15,
        //             length2: 0,
        //             maxSurfaceAngle: 80
        //         },
        //         labelLayout: function (params) {
        //             const isLeft = params.labelRect.x < myChart.getWidth() / 2;
        //             const points = params.labelLinePoints;
        //             // Update the end point.
        //             points[2][0] = isLeft
        //             ? params.labelRect.x
        //             : params.labelRect.x + params.labelRect.width;
        //             return {
        //             labelLinePoints: points
        //             };
        //         },
        //         data: data
        //         };
        //     })
        //     };

        //     option && myChart.setOption(option);

        // },
        // 当前页码改变
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.listInfo();
        },
        handleSizeChange(val){
            this.listQuery.size = val
            this.listInfo();
        },
        search(){
            this.listQuery.page = 1,
            this.listQuery.size = 10
            this.listInfo();
        },
        fileNumInfo(){
            this.$http({
                url:"api/user_file_num/",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                     organ_name:localStorage.getItem("organ_name")
                }
            }).then(res=>{
                this.surplus = res.data.surplus
                this.used_num = res.data.used_num
                // this.initChart()
                // console.log(res)
            })
        },
        
    },
}
</script>
<style>
/* .el-table--striped .el-table__body tr.el-table__row--striped.el-table__row--striped.el-table__row--striped td {
     background-color: #eae8e8; 
} */
</style>
<style lang="scss" scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: rgb(146, 80, 230);
    color: #FFF;
}
.el-steps--horizontal {
    white-space: nowrap;
}
::v-deep .el-table__expanded-cell[class*=cell] {
    background-color: white;
    padding: 20px 100px;
}
::v-deep .table_header{
    color: #333;
}
.index{
    padding:  1%;
    background-color: white;
}
.el-steps--simple {
padding: 15px;
border-radius: 10px;
background: #F5F7FA;
}
#main{
    position: relative;
    left: -50px;
    top: 0px;
    width: 400px;
    height: 260px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
</style>